
import React from 'react';

export const ExpectationsSection: React.FC = () => {
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-gray-900">Expectations</h3>
      <p className="text-gray-600 leading-relaxed">
        We'll review your application and connect with our PEO partners to get you the best quotes. If any additional information is needed, we'll contact you directly.
      </p>
      <ul className="space-y-3 ml-4">
        <li className="flex items-center text-gray-600">
          <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
          Complete applications typically receive quotes within 3-5 business days
        </li>
        <li className="flex items-center text-gray-600">
          <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
          If additional information is needed, our team will reach out to you directly
        </li>
        <li className="flex items-center text-gray-600">
          <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
          PEO partners may have specific questions that we'll coordinate on your behalf
        </li>
      </ul>
    </div>
  );
};

